<template>
	<div class="page-main">
		
		<div class="main-head">
			<h2 class="title">联盟院校</h2>
			<div class="search-box">
				<input class="input" type="text" placeholder="院校名称搜索" v-model="orgName">
				<span class="btn" @click="getCollegesList(1)"></span>
			</div>
		</div>
		
		<!-- 分类筛选 -->
		<div class="screen-mdl">
			<div class="datas" v-if="detail">
				<div class="li">
					<div class="value"><span>{{detail.allOrgCounts || 0}}</span>所</div>
					<p>院校</p>
				</div>
				<div class="li">
					<div class="value"><span>{{detail.bkOrgCounts || 0}}</span>所</div>
					<p>本科院校</p>
				</div>
				<div class="li">
					<div class="value"><span>{{detail.gzOrgCounts || 0}}</span>所</div>
					<p>高职院校</p>
				</div>
				<div class="li">
					<div class="value"><span>{{detail.crOrgCounts || 0}}</span>所</div>
					<p>成人高校</p>
				</div>
			</div>
			<div class="item">
				<ul class="list">
					<li :class="{act:item.val===schoolType}" v-for="(item,index) in schoolTypeList" :key="index"
						@click="changeScreen('schoolType',item.val)">{{item.title}}</li>
				</ul>
			</div>
		</div>
		
		<div class="colleges-wrap w1200">
			<!-- <div class="intro" v-if="detail">
				共{{detail.allOrgCounts || 0}}所院校，其中本科院校{{detail.bkOrgCounts || 0}}所、高职院校{{detail.gzOrgCounts || 0}}所、成人高校{{detail.crOrgCounts || 0}}所
			</div> -->
			<!-- <div class="intro" v-if="detail">共{{detail.allOrgCounts}}所院校，其中本科院校{{detail.bkOrgCounts}}所、高职院校{{detail.gzOrgCounts}}所、开放大学{{detail.kfOrgCounts}}所、其他院校{{detail.ohterOrgCounts}}所</div>
			 -->
			<!-- 课程资源列表 -->
			<ul class="school-list clearfix">
				<li v-for="(item,index) in listInfo.list" :key="index" @click="goDetail(item)">
					<div class="logo" :style="'background-image:url('+ (item.orgLogo || dfImg) +')'"></div>
					<h4>{{item.orgName}}</h4>
					<h5>{{item.orgEnName}}</h5>
					<div class="btm">
						<div class="btm-item">
							<div class="num"><span>{{item.courseCounts}}</span>门</div>
							<div class="text">课程</div>
						</div>
						<div class="btm-item">
							<div class="num"><span>{{item.teacherCounts}}</span>名</div>
							<div class="text">教师</div>
						</div>
					</div>
					
					<!-- <div class="logo" :style="'background-image:url('+ (item.orgLogo || dfImg) +')'"></div>
					<h4>{{item.orgName}}</h4>
					<h5>{{item.orgEnName}}</h5>
					<p>{{item.courseCounts}}门课程  |  {{item.teacherCounts}}名教师</p> -->
				</li>
			</ul>
			<van-empty v-if="!listInfo.list.length>0" description="没找到相应院校!" />
			
			<!-- 分页 -->
			<div class="paging" v-if="listInfo.pagingList.length>1">
				<span class="prev" @click="changePaging(listInfo.pageNum-1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
				<span :class="{active:index==listInfo.pageNum-1}" v-for="(item,index) in listInfo.pagingList" :key="index" 
					@click="changePaging(item,'listInfo')">{{item}}</span>
				<span class="next" @click="changePaging(listInfo.pageNum+1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
			</div>
			
		</div>
		
		
		<!-- 通用底部 -->
		<!-- <m-footer></m-footer> -->
	</div>
</template>

<script>
export default {
	data () {
		return {
			schoolTypeList:[
				{ title:'全部', val:'' },
				{ title:'本科院校', val:1 },
				{ title:'高职院校', val:2 },
				{ title:'成人高校', val:3 },
			],
			schoolType:'',	//院校类型:1本科院校 2高职院校 3成人高校
			orgName:'',
			
			detail:null,
			
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:12,
				total:0,
				pagingList:[],
			},
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getCollegesList()
	},
  
	computed:{
		
	},
  
	methods:{
		//切换筛选类型
		changeScreen(typeName,val){
			if(typeName==this[typeName]){return}
			this[typeName] = val
			this.getCollegesList(1)
		},
		
		
		//获取院校列表
		getCollegesList(){
			const {  pageSize, pageNum } = this.listInfo
			const { schoolType, orgName } = this
			this.$axios({
				url:`/jxedu/api/site/findPartnersOrg`,
				params:{
					orgName,
					schoolType,	//院校类型:1本科院校 2高职院校 3成人高校
					pageNum,
					pageSize
				}
			}).then(res=>{
				if(!res.data){return}
				let list = res.data.rows || []
				let total = res.data.total
				
				let num = Math.ceil(total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				
				this.detail = res.data
				this.listInfo.list = list
				this.listInfo.total = total
				this.listInfo.pagingList = pagingList
			})
		},
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'listInfo':  //开放课堂
					this.getCollegesList();
					break;
			}
		},
		
		//跳转详情
		goDetail(item){
			this.goUrl({name:'collegesDetail',params:{ id:item.orgId }})
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-collage.less';
.screen-mdl{
	padding:0; margin:0 22px; display:flex; justify-content: space-between; align-items: center;
	border-bottom: 1px solid rgba(216,218,221,0.5000); background:none;
	.item{
		.list{ flex:none; border-bottom:none;}
	}
	.datas{
		display:flex; padding:20px 0 18px;  box-sizing: border-box;
		.li{
			flex:1; display:flex; align-items: center; justify-content: center; flex-wrap:wrap;
			.value{
				font-size:14px; color:#2E75EB; line-height:22px; 
				span{ display:inline-block; font-size:28px;  font-weight: bold; line-height:28px; margin-right:4px; vertical-align: bottom;}
				
			}
			p{ font-size:14px; color:#AEB2B9; line-height:14px; width:100%; text-align: center; margin-top:6px;}
		}
	}
}

.colleges-wrap{
	padding:24px 22px 50px;
	.intro{ font-size:18px; color:#666666; margin-bottom:30px; }
	.school-list{
		li{
			width: 280px; height: 310px; margin-right:12px; 
			h4{ font-size:20px; }
			h5{ font-size:14px; }
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/colleges-list/tpl-pc.vue